








































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import Agency from "@/store/entities/agency";
import ajax from '@/lib/ajax';
import ReservationDetailModal from "../../../views/pages/flight/modals/reservationDetailModal.vue";
import ProcessFinanceTransaction from "./modals/processFinanceTransaction.vue";
@Component({
  components: { ReservationDetailModal, ProcessFinanceTransaction },
})
export default class AccountActivities extends Vue {
  mockData: any[] = [];
  accountLogs: any[] = [];
  headers: any[] = [];
  startDate: Date = null;
  endDate: Date = null;
  breadcrumbsItems: any[] = [];
  agency:Agency=new Agency();
  agencies: Agency[] = [];
  startDateMenu: boolean = false;
  endDateMenu: boolean = false;
  processTypes:any[]=[];
  totalAmount:number=0;
  processTypeItems:any[]=[];
  isOpenModal:boolean=false;
  isProcessModalOpen:boolean=false;
  isEditModalOpen:boolean=false;
  selectedItem:any=null;
  get getEndDate() {
    return this.endDate ? moment(this.endDate).format("DD-MM-yyyy") : "";
  }
  get getStartDate() {
    return this.startDate ? moment(this.startDate).format("DD-MM-yyyy") : "";
  }
  async getAccountLogs() {
    const hasHepsi = this.processTypes.some(p => p.id === -1);
    const backendTypes = this.processTypes
      .map(p => p.id)
      .filter(id => id !== -1 && id !== -2);
    const payload = {
      startDate:  this.startDate,
      endDate: this.endDate,
       agencyId: this.agency.id,
       processTypes: hasHepsi ? [] : backendTypes
    };
    const response = await ajax.post(
      "/api/services/app/Admin/GetAgencyAccountLogs",
      { ...payload } 
    );
    this.accountLogs = response.data.result.items;
  }

  get displayedLogs() {
    if (this.processTypes.some(p => p.id === -2)) {
      return this.accountLogs.filter(item => item.hasPendingRequest);
    }
    return this.accountLogs;
  }
  tableToExcel = (function() {
  var uri = 'data:application/vnd.ms-excel;base64,'
    , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
    , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
    , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
  return function(table, name) {
    if (!table.nodeType) table = document.getElementById(table)
    var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
    window.location.href = uri + base64(format(template, ctx))
  }
})()
async openReservationDetail(item){
  
  await this.$store.dispatch({
    type: "reservation/getFlightOrders",
    data: item,
  });
  this.isOpenModal=true;
}
closeModal() {
  this.isOpenModal = false;
}

openProcessModal(item: any) {
  this.selectedItem = item;
  this.isProcessModalOpen = true;
}

closeProcessModal() {
  this.isProcessModalOpen = false;
  this.selectedItem = null;
}

async onTransactionSaved() {
  this.closeProcessModal();
  await this.getAccountLogs();
}

isEditableTransaction(item: any) {
  // Bakiye Yükleme düzenlenemez
  if (item.processType === 0) {
    return false;
  }
  // Ödeme (transactionSubType === 'Odeme' ve note dolu) düzenlenebilir
  if (item.transactionSubType === 'Odeme' && item.note) {
    return true;
  }
  // Normal Satış düzenlenemez
  if (item.processType === 2) {
    return false;
  }
  // Diğerleri düzenlenebilir
  return true;
}

openEditModal(item: any) {
  this.selectedItem = item;
  this.isEditModalOpen = true;
}

closeEditModal() {
  this.isEditModalOpen = false;
  this.selectedItem = null;
}

async onEditSaved() {
  this.closeEditModal();
  await this.getAccountLogs();
}

async updatePaymentStatus(item: any) {
  try {
    await ajax.post("/api/services/app/Admin/UpdateAccountLogPaymentStatus", {
      id: item.id,
      isPaid: item.isPaid
    });
    if (item.isPaid) {
      this.$toast.success("Ödeme işlendi");
    } else {
      this.$toast.error("Ödeme iptal edildi");
    }
  } catch (error) {
    console.error("Ödeme durumu güncellenirken hata oluştu:", error);
    item.isPaid = !item.isPaid;
    this.$toast.error("İşlem sırasında hata oluştu");
  }
}
  clearForm(){
    this.agency=null;
    this.startDate=null;
    this.endDate=null;
    this.processTypes=[];
  }

  onProcessTypeChange(selected: any[]) {
    const hasHepsi = selected.some(s => s.id === -1);
    if (hasHepsi) {
      // "Hepsi" seçildi → sadece "Hepsi" kalsın, diğerlerini kaldır
      this.processTypes = [this.processTypeItems[0]];
    }
  }

  getTransactionLabel(item: any) {
    if (item.processType === 0) {
      return 'Bakiye Yükleme';
    }
    if (item.processType === 2) {
      return 'Satış';
    }
    return item.transactionSubType || '-';
  }

  getTransactionColor(item: any) {
    // İşlemde bekleyenler mor
    if (item.hasPendingRequest) {
      return '#9C27B0'; // Mor
    }
    if (item.processType === 0) {
      return 'green'; // Bakiye Yükleme - Yeşil
    }
    if (item.processType === 2) {
      return 'blue'; // Satış/Ödeme - Mavi
    }
    const subType = item.transactionSubType ? item.transactionSubType.toLowerCase() : '';
    if (subType.includes('iptal') || subType.includes('cancel')) {
      return 'red'; // İptal - Kırmızı
    }
    if (subType.includes('iade') || subType.includes('refund')) {
      return 'orange'; // Kısmi İade - Turuncu
    }
    if (subType.includes('odeme') || subType.includes('ödeme')) {
      return 'blue'; // Ödeme - Mavi
    }
    return 'grey'; // Varsayılan
  }

  getRowStyle(item: any) {
    // Bekleyen işlem varsa öncelikli renklendirme
    if (item.hasPendingRequest) {
      if (item.pendingType === 'Refund') {
        return { 'background-color': '#9C27B0', 'color': 'white' }; // Mor
      }
      if (item.pendingType === 'ExtraPay') {
        return { 'background-color': '#E91E63', 'color': 'white' }; // Pembe
      }
    }
    return {};
  }
  get calculateTotalAmount (){
    this.totalAmount = this.displayedLogs.reduce((total, item) => {
        return total + (item.processType === 2 ? - item.amount : item.amount);
      }, 0);
      return this.totalAmount.toFixed(2);
    };

  created() {
    this.getAgency();
    this.processTypeItems= [{'id':-1,'name':'Hepsi'},{'id':0,'name':'Bakiye'},{'id':2,'name':'Satış'},{'id':3,'name':'İade/İptal'},{'id':-2,'name':'İşle'}];
    (this.headers = [
      { text: 'Ödeme', value: 'isPaid' },
      { text: 'Acente', value: 'agency' },
      { text: 'Sipariş No', value: 'orderNo' },
      { text: 'İşlem Türü', value: 'processType' },
      { text: 'Tarih', value: 'date' },
      { text: 'Tutar', value: 'amount' },
      { text: 'Para Birimi', value: 'currency' },
      { text: 'Bekleyen İşlem', value: 'pendingRequest' },
      { text: 'Not', value: 'note' },
      { text: 'İşlem', value: 'action' },
    ]),
    

    this.breadcrumbsItems = [
      { text: 'Ana Sayfa', disabled: false, href: '/#/main/home' },
      { text: 'Finans', disabled: true },
      { text: 'Hesap Hareketleri', disabled: true },
    ];
  }

  async getAgency() {
    await this.$store.dispatch({
      type: "agency/getAgency",
    });
    this.agencies = this.$store.state.agency.list;
  }




}
